<template>
  <div class="costs">
    <div class="head row align-center column-s">
      <h1>BASE DE CUSTOS</h1>
      &nbsp;&nbsp;&nbsp;
      <Button
        :layout="showForm ? 'red-go' : 'green-go'"
        title="NOVA BASE DE CUSTO"
        @click="showForm = !showForm"
        >{{ showForm ? "x" : "+" }}</Button
      >
      <transition name="slide">
        <div v-if="showForm" class="new grid-11">
          <CostBaseForm :form="form" />
        </div>
      </transition>
    </div>
    <div class="list">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <input class="input search" v-model="search" placeholder="Pesquisar" />

        <div class="head row justify-space">
          <div class="grid-1">ID</div>
          <div class="grid-3">Nome</div>
          <div class="grid-2">Criado</div>
          <div class="grid-2">Alterado</div>
        </div>
        <div class="content">
          <div v-for="(item, i) of filtered" :key="'item' + i">
            <div class="line row justify-space" @click="toggle(i)">
              <div class="grid-1">{{ item.id }}</div>
              <div class="grid-3">{{ item.nome }}</div>
              <div class="grid-2">{{ item.criado_em | date }}</div>
              <div class="grid-2">{{ item.alterado_em | date }}</div>
            </div>
            <div v-if="item.show" class="edit row wrap column-s">
              <CostBaseForm v-if="item.show" :form="item" />
              <Loader layout="small" v-else />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import CostBaseForm from "@/views/admin/components/CostBaseForm.vue";

export default {
  name: "CostsBase",
  components: {
    Button,
    CostBaseForm,
    Loader,
  },
  data() {
    return {
      loader: true,
      showForm: false,
      form: { send: this.create },
      search: "",
      list: [],
    };
  },
  methods: {
    ...mapActions("admin", [
      "BASECOST_GET",
      "BASECOST_LIST",
      "BASECOST_CREATE",
      "BASECOST_DEL",
      "BASECOST_UPDATE",
    ]),
    async load() {
      this.loader = true;
      await this.BASECOST_LIST({}).then(({ data }) => (this.list = data));
      this.loader = false;
    },
    create(form) {
      return this.BASECOST_CREATE(form).then(() => this.load());
    },
    del(item) {
      if (confirm(`Deseja excluir ${item.nome}?`)) {
        return this.BASECOST_DEL(item.id).then(() => this.load());
      }
    },
    update(item) {
      this.BASECOST_UPDATE({ ...item, params: item.id }).then(({ status }) => {
        if (status == 200) this.load();
      });
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;

      if (this.list[index].show) {
        await this.BASECOST_GET(this.list[index].id).then(({ data }) => {
          this.list[index].update = true;
          this.list[index] = { ...this.list[index], ...data };
          this.list[index].send = () => this.update(this.list[index]);
          this.list[index].del = () => this.del(this.list[index]);
          this.list = [...this.list];
        });
      }
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("costBase");
    this.load();
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.list.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.costs
    @include page
</style>
